document.addEventListener('DOMContentLoaded', function() {
  var overlay = document.getElementById('sizeChartPopupOverlay');
  if (overlay && overlay.parentElement !== document.body) {
    document.body.appendChild(overlay);
  }
});

function openSizeChartPopup() {
  var overlay = document.getElementById('sizeChartPopupOverlay');
  if (overlay) {
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }
}

function closeSizeChartPopup(e) {
  var overlay = document.getElementById('sizeChartPopupOverlay');
  if (!overlay) return;
  if (e.target.id === 'sizeChartPopupOverlay' || e.target.classList.contains('size-chart-popup-close')) {
    overlay.classList.remove('active');
    document.body.style.overflow = '';
  }
}

document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape') {
    var overlay = document.getElementById('sizeChartPopupOverlay');
    if (overlay && overlay.classList.contains('active')) {
      overlay.classList.remove('active');
      document.body.style.overflow = '';
    }
  }
});